import useUsers from "../../settings/users/users/hooks/useUsers";

export default useUsers;
